import * as React from "react";
import { cn } from "../lib/utils";
import { TONES, type Tone } from "./theme-tokens";

// Standardized square icon "well" used next to a title, stat value, or
// list item. Replaces scattered `h-8/9/10 w-* rounded-lg/xl bg-X-50
// flex items-center justify-center` blocks that had drifted on size
// and radius across the admin console.
//
// One size, one radius, five tones — that's the entire surface. If you
// want a different size, think twice: the point is that every icon
// well looks the same across the product.

interface IconBadgeProps {
  icon: React.ComponentType<{ className?: string }>;
  tone?: Tone;
  className?: string;
  /** Smaller variant for table cells and tight list rows. */
  size?: "sm" | "md";
}

export function IconBadge({
  icon: Icon,
  tone = "brand",
  className,
  size = "md",
}: IconBadgeProps) {
  const t = TONES[tone];
  const sizeClasses =
    size === "sm"
      ? "h-7 w-7 rounded-md [&>svg]:h-3.5 [&>svg]:w-3.5"
      : "h-9 w-9 rounded-lg [&>svg]:h-4 [&>svg]:w-4";
  return (
    <div
      className={cn(
        "inline-flex items-center justify-center flex-shrink-0",
        sizeClasses,
        t.bg,
        t.fg,
        className,
      )}
    >
      <Icon className="" />
    </div>
  );
}
